import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { consultationsAPI, adminAPI } from '@/lib/api';
import { Calendar, User, Mail, Phone, MapPin } from 'lucide-react';

const AdminConsultations = () => {
  const navigate = useNavigate();
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAndFetch = async () => {
      try {
        await adminAPI.verify();
        const response = await consultationsAPI.getAll();
        setConsultations(response.data);
      } catch (error) {
        navigate('/admin/login');
      } finally {
        setLoading(false);
      }
    };
    verifyAndFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><div className="text-[#D4AF37]">در حال بارگذاری...</div></div>;
  }

  return (
    <div className="min-h-screen bg-[#121212] py-8" data-testid="admin-consultations-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-light text-white">درخواست‌های مشاوره</h1>
          <div className="text-zinc-400">{consultations.length} درخواست</div>
        </div>

        <div className="space-y-4">
          {consultations.map((consultation) => (
            <div
              key={consultation.id}
              data-testid={`consultation-${consultation.id}`}
              className="glass-effect border border-white/10 rounded-xl p-6 hover:border-[#D4AF37]/30 transition-all"
            >
              <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-4">
                    <h3 className="text-lg font-medium text-white">{consultation.full_name}</h3>
                    <span className="px-3 py-1 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-xs">
                      {consultation.request_type}
                    </span>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    <div className="flex items-center gap-2 text-zinc-400">
                      <Phone size={14} />
                      <span>{consultation.phone}</span>
                    </div>
                    <div className="flex items-center gap-2 text-zinc-400">
                      <Mail size={14} />
                      <span>{consultation.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-zinc-400">
                      <MapPin size={14} />
                      <span>{consultation.current_country} → {consultation.destination_country}</span>
                    </div>
                    <div className="flex items-center gap-2 text-zinc-400">
                      <Calendar size={14} />
                      <span>{new Date(consultation.created_at).toLocaleDateString('fa-IR')}</span>
                    </div>
                  </div>
                  {consultation.description && (
                    <p className="text-sm text-zinc-300 mt-4 p-3 bg-white/5 rounded-lg">
                      {consultation.description}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}

          {consultations.length === 0 && (
            <div className="glass-effect border border-white/10 rounded-xl p-12 text-center">
              <p className="text-zinc-400">هنوز درخواستی ثبت نشده است</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminConsultations;